import React from 'react';
import SCheckbox from 'components/Checkbox/style';
import { TCheckbox } from 'components/Checkbox/types';

const Checkbox = (props: TCheckbox) => {
  const { label } = props;
  return <SCheckbox {...props}>{label} </SCheckbox>;
};
export default Checkbox;
